<template>
  <div id="index" style="max-width:600px;margin:0 auto;">
    <!-- <v-layout>
      <v-btn flat small color="primary" :to="{name: 'searchFood'}">
        <v-icon :size="30">keyboard_arrow_left</v-icon>商品ページへ
      </v-btn>
      <v-spacer></v-spacer>
      <v-chip flat dark color="primary">カラログを登録</v-chip>
    </v-layout> -->
    <v-stepper v-model="stepper">
      <!-- ステッパーのヘッダー -->
      <v-card flat>
        <v-container style="padding:5px 16px;">
          <v-layout row wrap>
            <v-flex xs4 style="text-align:center;">
              <v-chip small color="white" text-color="primary">
                <v-avatar left class="primary white--text">
                  <span v-if="stepper==1">1</span>
                  <v-icon v-else>check</v-icon>
                </v-avatar>
                カラログ入力
              </v-chip>
            </v-flex>
            <v-flex xs4 style="padding-top:16px;">
              <hr style="border-color: rgba(0, 0, 0, 0.12);border-width: thin 0 0 0;">
            </v-flex>
            <v-flex xs4 style="text-align:center;">
              <v-chip v-if="stepper==1" small color="white" text-color="grey">
                <v-avatar left class="grey white--text">2</v-avatar>辛さ比較
              </v-chip>
              <v-chip v-if="stepper>=2" small color="white" text-color="primary">
                <v-avatar left class="primary white--text">
                  <span v-if="stepper==2">2</span>
                  <v-icon v-else-if="stepper>=3">check</v-icon>
                </v-avatar>辛さ比較
              </v-chip>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <!-- ／ステッパーのヘッダー -->
      <v-stepper-header style="display:none;">
        <v-stepper-step :complete="stepper > 1" step="1">カラログ</v-stepper-step>
        <v-stepper-step :complete="stepper > 2" step="2">辛さ比較！</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
            <!-- 食べた食品 -->
            <v-card v-if="mode=='food'" flat style="margin-bottom:16px;">
              <food-card-min
                :name="food.name"
                :imageurl="imageurls[0]"
                label="選択中の食品"
              ></food-card-min>
            </v-card>
            <!-- ／食べた食品 -->

            <review-form
              @onSendAccept='onSendAccept'
              @onSendFin='onSendFin'
              @onMessage='onMessage'
              :mode='mode'
            ></review-form>
            <!-- <v-btn @click="stepper=2" block dark large color="red">次へ</v-btn> -->
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2" style="padding:0;">
          <v-card>
            <karasa-hikaku-form
             v-if="mode=='food' || stepper>=2"
             @onFinish='onHikakuFinish'
             @onMessage='onMessage'
             @onFirstRank='onFirstRank'
            ></karasa-hikaku-form>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import FoodCardMin from '@/components/card/FoodCardMin.vue'
import ReviewForm from '@/components/form/ReviewForm.vue'
import KarasaHikakuForm from '@/components/form/KarasaHikakuForm2.vue'
export default {
  name: 'ReviewView',
  data () {
    return {
      stepper: 0,
      mode: 'food',
      isFirst: false,
      postId: '',
      isFormFinish: false,
      isHikakuFinish: false
    }
  },
  computed: {
    food () {
      return this.$store.state.temp.foodData
    },
    imageurls () {
      return this.$store.state.temp.images
    }
  },
  created () {
    this.scrollIni()
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode
      if (this.mode !== 'food') {
        this.$store.commit('deleteTempFoodData')
      }
    }
  },
  methods: {
    onFinSecound () {
      console.log('onFinSecound')
    },
    resetRank () {
      console.log('resetRank')
    },
    onSendAccept (postId) {
      if (postId) this.postId = postId
      if (this.isFirst) {
        this.isHikakuFinish = true
        this.onFinish()
      } else {
        this.stepper = 2
        this.scrollIni()
      }
    },
    onSendFin () {
      this.isFormFinish = true
      this.onFinish()
    },
    onFirstRank () {
      this.isFirst = true
      this.isHikakuFinish = true
      if (this.stepper === 2) {
        this.onSendAccept()
      }
    },
    scrollIni () {
      window.scrollTo(0, 0)
    },
    onHikakuFinish () {
      this.isHikakuFinish = true
      this.onFinish()
    },
    onFinish () {
      if (this.isFormFinish && this.isHikakuFinish) {
        this.$store.commit('initPost')
        let message = {
          group: 'messageBottom',
          type: 'success',
          title: 'Thank you !!',
          text: 'カライモノレビューを投稿しました！'
        }
        this.onMessage(message)

        this.$router.push({name: 'searchReviewDetail', params: {id: this.postId}})
      }
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  components: {
    FoodCardMin,
    ReviewForm,
    KarasaHikakuForm
  },
  head: {
    title () {
      return {
        inner: 'カラログ投稿',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミサイト「カライイネ」にカラログを投稿しよう'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  },
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>